var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32969 14.25C4.04062 14.25 3 13.2469 3 12C3 10.7578 4.04062 9.75 5.32969 9.75C6.62344 9.75 7.66406 10.7578 7.66406 12C7.66406 13.2469 6.62344 14.25 5.32969 14.25ZM12 14.25C10.711 14.25 9.66565 13.2469 9.66565 12C9.66565 10.7578 10.711 9.75 12 9.75C13.2891 9.75 14.3297 10.7578 14.3297 12C14.3297 13.2469 13.2891 14.25 12 14.25ZM16.3313 12C16.3313 13.2469 17.3766 14.25 18.6657 14.25C19.9594 14.25 21 13.2469 21 12C21 10.7578 19.9547 9.75 18.6657 9.75C17.3719 9.75 16.3313 10.7578 16.3313 12Z",
    fill: "#2A1B5B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.19b2af8053b01486f67e86df3fda48d5.svg";
export { ForwardRef as ReactComponent };